import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { getDashboardRouteByRole } from '../../utils/navigationUtils';
import { Shuffle } from 'lucide-react';

const RoleSwitcher = ({ buttonClassName = '' }) => {
  const { roles, activeRole, setActiveRole } = useAuth();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  if (!roles || roles.length <= 1) return null;

  const handleSwitchRole = (role) => {
    setActiveRole(role);
    const route = getDashboardRouteByRole(role);
    navigate(route, { replace: true });
    setOpen(false);
  };

  return (
    <div className="relative">
      <button onClick={() => setOpen((v) => !v)} className={`inline-flex items-center px-3 py-1.5 rounded-md border text-sm ${buttonClassName}`} title={`Current role: ${activeRole}`}>
        <Shuffle className="h-4 w-4 mr-2" />
        {activeRole}
      </button>
      {open && (
        <div className="absolute right-0 mt-2 w-56 bg-white border rounded-md shadow-lg z-50">
          <div className="py-1">
            {roles.map((r) => (
              <button key={r} onClick={() => handleSwitchRole(r)} className={`w-full text-left px-3 py-2 text-sm hover:bg-teal-50 ${r === activeRole ? 'text-teal-700 font-medium' : 'text-gray-700'}`}>
                Switch to {r}
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default RoleSwitcher;
